package com.neurobs.react

import scala.scalajs.js

case class ElementModifiers(classString: String, styleAttributes: Seq[(String, js.Any)]) {
  def values = (classString, styleAttributes)

  def createStyle = StyleUtil.makeStyle(styleAttributes:_*)
  def withExtraAttrs(extraAttrs: (String, js.Any)*): ElementModifiers = this.copy(styleAttributes = styleAttributes ++ extraAttrs)
}

object ElementModifiers {
  implicit val defaultModifiers = ElementModifiers("", Seq())
  implicit def valuesToModifiers(values: (String, Seq[(String, js.Any)])) = ElementModifiers(values._1, values._2)
  implicit def classToModifiers(classString: String) = ElementModifiers(classString, Seq())
  implicit def styleToModifiers(styleAttributes: Seq[(String, js.Any)]) = ElementModifiers("", styleAttributes)
}
